import { render, staticRenderFns } from "./scientific.vue?vue&type=template&id=6e498bde&scoped=true"
import script from "./scientific.vue?vue&type=script&lang=js"
export * from "./scientific.vue?vue&type=script&lang=js"
import style0 from "./scientific.vue?vue&type=style&index=0&id=6e498bde&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e498bde",
  null
  
)

export default component.exports